import React from 'react';
import SiteSummaryCard from './overview/SiteSummaryCard';
import LiveBotTrackingGraph from './overview/LiveBotTrackingGraph';
import WhenStartedGraph from './overview/WhenStartedGraph';
import TrafficWhenStartedCard from './overview/TrafficWhenStartedCard';

const SiteOverviewSummary = ({site, setReady}) => {
  return (
    <>
      <div className="section-box overview-table">
        <SiteSummaryCard site={site} />
        <LiveBotTrackingGraph site={site} setReady={setReady}/>
        <TrafficWhenStartedCard site={site} />
        <WhenStartedGraph site={site} setReady={setReady}/>
      </div>
    </>
  );
};

export default SiteOverviewSummary;
